export default {
  namespaced: true,
  state: {
    all: [],
    loading: false
  },
  getters: {
    all: state => state.all,
    find: state => id => state.all.find(component => component.id == id),
    loading: state => state.loading
  },
  mutations: {
    startLoading(state) {
      state.loading = true
    },
    stopLoading(state) {
      state.loading = false
    },
    // This `setAll` replaces records and keeps the rest since multiple profile
    // qualification could be on the page at the same time
    setAll(state, components) {
      const ids = components.map(o => o.id)
      state.all = state.all.filter(component => ids.indexOf(component.id) === -1).concat(components)
      state.loading = false
    },
    set(state, component) {
      state.all = state.all.filter(o => o.id != component.id)
      state.all.push(component)
    },
    remove(state, id) {
      state.all = state.all.filter(o => o.id != id)
    }
  },
  actions: {
    fetchAll({ commit }, { institution, qualificationType } = {}) {
      this.$authorize('list', 'QualificationComponent')

      commit('startLoading')
      let action = 'admin/qualification_components'
      const params = [
        institution ? `institution=${institution.id}` : '',
        qualificationType ? `qualification_type=${qualificationType.id}` : ''
      ]
        .filter(s => s.length)
        .join('&')

      if (params.length) {
        action = `${action}?${params}`
      }

      return Vue.$http.get(action).then(response => commit('setAll', response.data), error => commit('stopLoading'))
    },
    fetch({ commit }, id) {
      this.$authorize('read', 'QualificationComponent')

      return Vue.$http.get(`admin/qualification_components/${id}`).then(response => commit('set', response.data))
    },
    create({ commit }, qualificationComponent) {
      this.$authorize('create', 'QualificationComponent')

      return Vue.$http.post('admin/qualification_components', { qualificationComponent }).then(
        response => {
          commit('set', response.data)
          commit('snackbar', { text: 'Qualification component created', type: 'success' }, { root: true })
        },
        error => {
          commit('snackbar', { text: 'Qualification component could not be created', type: 'error' }, { root: true })
          return Object.assign(qualificationComponent, error.response.data)
        }
      )
    },
    update({ commit }, qualificationComponent) {
      this.$authorize('edit', 'QualificationComponent')

      return Vue.$http
        .patch(`admin/qualification_components/${qualificationComponent.id}`, { qualificationComponent })
        .then(
          response => {
            commit('snackbar', { text: 'Qualification component updated', type: 'success' }, { root: true })
            commit('set', response.data)
          },
          error => {
            commit('snackbar', { text: 'Qualification component could not be updated', type: 'error' }, { root: true })
            return Object.assign(qualificationComponent, error.response.data)
          }
        )
    },
    destroy({ commit }, id) {
      this.$authorize('delete', 'QualificationComponent')

      return Vue.$http.delete(`admin/qualification_components/${id}`).then(
        response => {
          commit('remove', id)
          commit('snackbar', { text: 'Qualification component was removed', type: 'success' }, { root: true })
        },
        error =>
          commit('snackbar', { text: 'Qualification component could not be removed', type: 'error' }, { root: true })
      )
    }
  }
}
